<template>
  <div class="index" v-cloak>
    <div class="header acea-row row-center-wrapper">
      <!-- <div class="logo"><img :src="logoUrl" /></div> -->
      <router-link :to="'/search'" class="search acea-row row-middle">
        <span class="iconfont icon-xiazai5"></span>搜索商品
      </router-link>
    </div>
    <div class="slider-banner banner">
      <swiper :options="swiperOption" v-if="banner.length > 0">
        <swiper-slide v-for="(item, index) in banner" :key="index">
          <router-link
            :to="item.wap_url ? item.wap_url : ''"
            class="search acea-row row-middle"
          >
            <img :src="item.pic" />
          </router-link>
        </swiper-slide>
        <div class="swiper-pagination paginationBanner" slot="pagination"></div>
      </swiper>
    </div>
    <div class="nav acea-row">
      <router-link
        :to="item.wap_url ? item.wap_url : ''"
        class="item"
        v-for="(item, index) in menus"
        :key="index"
      >
        <div class="pictrue"><img :src="item.pic" /></div>
        <div>{{ item.name }}</div>
      </router-link>
    </div>
    <div class="news acea-row row-between-wrapper">
      <div class="pictrue"><img src="@assets/images/news.png" /></div>
      <div class="swiper-no-swiping new-banner">
        <swiper
          class="swiper-wrapper"
          :options="swiperRoll"
          v-if="roll.length > 0"
        >
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in roll"
            :key="index"
          >
            <router-link
              :to="'/news_detail/'+item.id"
              class="acea-row row-between-wrapper"
            >
              <div class="text acea-row row-between-wrapper">
                <div class="label" v-if="item.show === '是'">最新</div>
                <div class="newsTitle line1">{{ item.title }}</div>
              </div>
              <div class="iconfont icon-xiangyou"></div>
            </router-link>
          </swiper-slide>
        </swiper>
      </div>
    </div>
      
    <div
      class="wrapper"
      v-if="info.bastList.length > 0 || info.bastBanner.length > 0"
    >
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">精品推荐</div>
          <div class="line1">{{ info.bastInfo }}</div>
        </div>
        <router-link :to="{ path: '/hot_new_goods/' + 1 }" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
      <div class="slider-banner boutique">
        <swiper class="swiper-wrapper" :options="swiperBoutique">
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in info.bastBanner"
            :key="index"
          >
            <router-link :to="item.wap_link ? item.wap_link : ''"
              ><img :src="item.img"
            /></router-link>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination paginationBoutique"></div>
      </div>
      <Good-list :good-list="info.bastList" :is-sort="false"></Good-list>
    </div>
 
    <Coupon-window
      :coupon-list="couponList"
      v-if="showCoupon"
      @checked="couponClose"
      @close="couponClose"
    ></Coupon-window>
    <div style="height:1.2rem;"></div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import GoodList from "@components/GoodList";
//import PromotionGood from "@components/PromotionGood";
import CouponWindow from "@components/CouponWindow";
import { getHomeData, getShare } from "@api/public";
import cookie from "@utils/store/cookie";
import { openShareAll } from "@libs/wechat";
import { isWeixin } from "@utils/index";

const HAS_COUPON_WINDOW = "has_coupon_window";

export default {
  name: "Index",
  components: {
    swiper,
    swiperSlide,
    GoodList,
    CouponWindow
  },
  props: {},
  data: function() {
    return {
      showCoupon: false,
      logoUrl: "",
      banner: [],
      menus: [],
      roll: [],
      activity: [],
      activityOne: {},
      info: {
        //fastList: [],
        bastBanner: [],
        firstList: [],
        bastList: []
      },
      pkList: [],
      salseRankList: [],
      likeInfo: [],
      lovely: [],
      benefit: [],
      couponList: [],
      swiperOption: {
        pagination: {
          el: ".paginationBanner",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperRoll: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperScroll: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      swiperBoutique: {
        pagination: {
          el: ".paginationBoutique",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperProducts: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      }
    };
  },
  mounted: function() {
    let that = this;
    getHomeData().then(res => {
      that.logoUrl = res.data.logoUrl;
      that.$set(that, "banner", res.data.banner);
      that.$set(that, "menus", res.data.menus);
      that.$set(that, "roll", res.data.roll);
      that.$set(that, "activity", res.data.activity);
      if (res.data.activity.length) {
        var activityOne = res.data.activity.shift();
        that.$set(that, "activityOne", activityOne);
      }
      that.$set(that, "info", res.data.info);
      that.$set(that, "pkList", res.data.pkList);
      that.$set(that, "salseRankList", res.data.salseRankList);
      //that.$set(that, "likeInfo", res.data.likeInfo);
      // that.$set(
      //   that,
      //   "lovely",
      //   res.data.lovely.length ? res.data.lovely[0] : {}
      // );
      // that.$set(that, "benefit", res.data.benefit);
      that.$set(that, "couponList", res.data.couponList);
      that.setOpenShare();
      this.showCoupon =
        !cookie.has(HAS_COUPON_WINDOW) &&
        res.data.couponList.some(coupon => coupon.is_use);
    });
  },
  methods: {
    getLKing(pk) {
      //获取左侧是否是winner
      if (pk.win_uid == pk.s_uid) {
        return "dp_pk_m";
      }
    },
    getRKing(pk) {
      if (pk.win_uid == pk.r_uid) {
        return "dp_pk_m";
      }
    },
    getLWidth(pk) {
      var lwidth;
      if (pk.s_salse == 0 && pk.r_salse == 0) {
        return 0;
      }
      console.log(pk.id + "-" + pk.r_salse + "," + pk.s_salse);
      lwidth =
        (parseInt(pk.s_salse) / (parseInt(pk.r_salse) + parseInt(pk.s_salse))) *
        100;
      console.log(lwidth);
      lwidth = lwidth.toFixed(2);
      return lwidth;
    },
    getLeftWidth(pk) {
      var lwidth = this.getLWidth(pk);
      return { width: lwidth + "%" };
    },
    getRightWidth(pk) {
      var lwidth = this.getLWidth(pk);
      var rwidth = 100 - lwidth;
      return { width: rwidth + "%" };
    },
    couponClose() {
      cookie.set(HAS_COUPON_WINDOW, 1);
    },
    setOpenShare: function() {
      if (isWeixin()) {
        getShare().then(res => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: location.href,
            imgUrl: data.img
          };
          openShareAll(configAppMessage);
        });
      }
    }
  }
};
</script>
<style scoped>
.index {
  background-color: #fff;
}

.yuepaihang {
  width: 6.9rem;
  border-radius: 0.2rem;
  background-color: #fff;
  margin: -0.7rem auto 0 auto;
  min-height: 3rem;
}
.dp_one,
.dp_two,
.dp_three {
  min-height: 3.5rem;
}
.dp_one {
  width: 36%;
  background: url(../../assets/images/dp_no1_back.png);
  background-repeat: no-repeat;
  background-size: contain;
  margin-top: -0.5rem;
}
.dp_two {
  width: 32%;
}
.dp_three {
  width: 32%;
}
.yuepaihang_item_touxiang {
  text-align: center;
  padding: 20px 10px 10px 10px;
  position: relative;
  height: 2rem;
}
.dp_one .yuepaihang_item_touxiang {
  height: 2.22rem;
}
.yuepaihang_item_back,
.yuepaihang_item_img {
  position: absolute;
}
.yuepaihang_item_back {
  top: 0.4rem;
  left: 0.65rem;
  z-index: 1;
  width: 0.9rem;
}
.yuepaihang_item_img {
  top: 0.2rem;
  left: 0.28rem;
  z-index: 2;
  width: 1.7rem;
}

.dp_one .yuepaihang_item_back {
  top: 0.6rem;
  left: 0.65rem;
  width: 1.2rem;
}
.dp_one .yuepaihang_item_img {
  left: 0.33rem;
  width: 1.8rem;
}

.yuepaihang_xiaoliang {
  font-size: 0.3rem;
  text-align: center;
  color: #ff6a48;
}
.yuepaihang_nickname {
  font-size: 0.3rem;
  text-align: center;
}
</style>